import {
  NOTE_CONTENT_MAX_BYTES,
  NOTE_TITLE_MAX_LENGTH,
  NOTE_TITLE_MIN_LENGTH,
  hasNoteContent as hasSanitizedNoteContent,
  sanitizeNoteContent,
  sanitizeNoteTitle,
  validateNoteContent,
} from "../utils/noteSanitize";

export {
  NOTE_CONTENT_MAX_BYTES,
  NOTE_TITLE_MAX_LENGTH,
  NOTE_TITLE_MIN_LENGTH,
  sanitizeNoteContent,
  sanitizeNoteTitle,
  validateNoteContent,
};

export const NOTE_CATEGORIES = {
  REPERES_TEXTE: "reperes_texte",
  REPERES_HISTORIQUES: "reperes_historiques",
  FAITS_INTERESSANTS: "faits_interessants",
  ESSAIS_LITTERAIRES: "essais_litteraires",
  AUTRE: "autre",
};

export const NOTE_CATEGORY_LABELS = {
  [NOTE_CATEGORIES.REPERES_TEXTE]: "Repères de texte",
  [NOTE_CATEGORIES.REPERES_HISTORIQUES]: "Repères historiques",
  [NOTE_CATEGORIES.FAITS_INTERESSANTS]: "Faits intéressants",
  [NOTE_CATEGORIES.ESSAIS_LITTERAIRES]: "Essais littéraires",
  [NOTE_CATEGORIES.AUTRE]: "Autre",
};

export const NOTE_CATEGORY_OPTIONS = Object.values(NOTE_CATEGORIES).map((value) => ({
  value,
  label: NOTE_CATEGORY_LABELS[value],
}));

export const DEFAULT_NOTE_CATEGORY = NOTE_CATEGORIES.AUTRE;
export const DEFAULT_NOTE_TITLE = "Nouvelle note";

export const VALID_NOTE_CATEGORIES = new Set(Object.values(NOTE_CATEGORIES));

export function hasNoteContent(content) {
  return hasSanitizedNoteContent(content);
}

export function normalizeNoteTitleInput(title) {
  return sanitizeNoteTitle(title);
}

export function canPersistNoteDraft(draft) {
  const title = sanitizeNoteTitle(draft?.title);
  const content = sanitizeNoteContent(draft?.content);
  return (
    title.length >= NOTE_TITLE_MIN_LENGTH &&
    title.length <= NOTE_TITLE_MAX_LENGTH &&
    !validateNoteContent(content)
  );
}
